<template>
  <v-card class="pa-3 ma-0">
    <v-layout row align-center justify-space-between>
      <h2>{{ isEdit ? 'Edit' : 'Add' }} View</h2>
      <v-btn
        flat
        fab
        small
        type="button"
        class="ma-0"
        data-dismiss="modal"
        @click="$emit('close')"
        aria-label="Close">
        <v-icon>close</v-icon>
      </v-btn>
    </v-layout>
    <v-alert :value="true" type="error" v-if="err">
      {{err}}
    </v-alert>
    <div class="v-table__overflow" v-else>
      <table class="v-datatable v-table theme--light">
        <thead>
          <tr>
            <th role="columnheader" scope="col" class="column text-xs-left">Language</th>
            <th role="columnheader" scope="col" class="column text-xs-left">Name</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in view.names" :key="index">
            <td>{{item.language}}</td>
            <td>
              <v-text-field
                type="text"
                :value="item.name"
                v-model="item.name" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <v-layout row wrap align-center>
      <template v-for="type in orderTypes">
        <v-flex xs4 v-if="!selectedOrderTypes.includes(type) || view.orderTypes.includes(type)">
          <v-checkbox @change="$emit('changeSelectedOrderTypes', type)" color="primary" v-model="view.orderTypes" :value="type" :label="$lang.labels[type]" hide-details/>
        </v-flex>
      </template>
    </v-layout>
    <v-layout justify-end align-center>
      <v-btn fab small :color="view.isDefault ? 'primary': 'disabled'" @click="$set(view, 'isDefault', !view.isDefault)">
        <v-icon>bookmark</v-icon>
      </v-btn>
      <div class="text-xs-center" v-if="languages.length > 0">
        <v-menu>
          <v-btn
            flat
            outline
            slot="activator"
            type="button">
            Add language
            <v-icon>keyboard_arrow_down</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile
              v-for="(lang, index) in languages"
              :key="index"
              v-if="lang !== language"
              @click="addLang(lang.value, index)">
              <v-list-tile-title>
                {{lang.text}}
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
      <v-btn color="primary" @click="submit()">Submit</v-btn>
    </v-layout>
  </v-card>
</template>

<script>
  export default {
    props: ['edit', 'maxViewId', 'orderTypes', 'selectedOrderTypes'],
    data() {
      return {
        err: '',
        language: this.$cookie.get('lang') || 'en',
        languages: JSON.parse(localStorage.languages),
        view: {
          names: [
            {
              language: this.$cookie.get('lang') || 'en',
              name: '',
            },
          ],
          isDefault: false,
          orderTypes: [],
        },
        isEdit: false,
      };
    },
    methods: {
      addLang(lang, langIndex) {
        this.view.names.push({
          language: lang,
          name: '',
        });
        this.languages.splice(langIndex, 1);
      },
      submit() {
        const view = {};
        if(!this.isEdit){
          view['viewId'] = this.maxViewId+1;
        }else{
          view['viewId'] = this.edit.view.viewId;
        }
        view.name = {};
        this.view.names.forEach((entry) => {
          if (entry.name !== '') {
            view.name[entry.language] = entry.name;
          }
        });
        view.isDefault = this.view.isDefault;
        view.orderTypes = this.view.orderTypes
        if (this.isEdit) {
          const index = this.edit.index;
          this.$emit('update', {
            view,
            index,
          });
        } else {
          this.$emit('submit', view);
        }
        this.$emit('close');
      },
    },
    created() {
      if (this.edit) {
        this.isEdit = true;
        const view = this.edit.view;
        const languages = Object.keys(view.name);
        this.view.names = [];
        this.view.isDefault = view.isDefault;
        this.view.orderTypes = view.orderTypes || [];
        languages.forEach((language) => {
          let index = null;
          this.view.names.push({
            language,
            name: view.name[language],
          });
          this.languages.forEach((lang, i) => {
            if (lang.value === language) {
              index = i;
            }
          });
          if (index !== null) {
            this.languages.splice(index, 1);
          }
        });
      }
    },
  };
</script>

<style lang="scss" scoped>
  .err {
    font-size: 16px;
    padding: 15px;
    padding-top: 0;
  }
  .modal {
    display: block;
    background: rgba(0, 0, 0, 0.5);

    &-body {
      max-height: 80vh;
      overflow-y: auto;
    }
  }
  @media (min-width: 576px) {
    .modal-dialog {
        max-width: 70%;
    }
  }

</style>



// WEBPACK FOOTER //
// ViewsModal.vue?6bdc0d36